import { Toaster } from '@/components/shadcn/sonner.tsx'
import { Outlet, createRootRouteWithContext, useRouterState } from '@tanstack/react-router'
import { useEffect } from 'react'

export interface AuthContext {
  isAuthenticated: boolean | null
  isAuthenticatedNextRoute: string | null
}

interface MyRouterContext {
  auth: AuthContext
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: RootRoute,
})

function RouteChangeTracker() {
  const location = useRouterState({
    select: (state) => state.location,
  })

  useEffect(() => {
    // Check if _wos_user does not exist in localStorage meaning, not logged in
    if (!localStorage.getItem('_wos_user')) {
      const currentUrl = window.location.href
      if (!currentUrl.includes('login') && !currentUrl.includes('sign-up')) {
        sessionStorage.setItem('lastPath', currentUrl)
      }
    }
  }, [location.href])

  return null
}

function RootRoute() {
  return (
    <>
      <RouteChangeTracker />

      <Outlet />
      <Toaster />
    </>
  )
}
